const indexItems = [
  { title: '国产电视剧全集', desc: '收录最新国产剧全集完整版，涵盖古装、悬疑、都市、年代等类型', icon: 'ri-china-railway-line', count: '850+部' },
  { title: '韩剧完整版合集', desc: '热门韩剧大结局一网打尽，爱情、复仇、奇幻题材全覆盖', icon: 'ri-heart-pulse-line', count: '420+部' },
  { title: '美剧在线全集', desc: '经典美剧全季完整版在线观看，剧情、科幻、喜剧一应俱全', icon: 'ri-global-line', count: '380+部' },
  { title: '日剧高清全集', desc: '高分日剧完整版收录，治愈、悬疑、职场剧类型丰富', icon: 'ri-sun-line', count: '260+部' },
  { title: '港剧经典重温', desc: 'TVB经典港剧全集在线看，警匪、家族、职场剧回忆满满', icon: 'ri-building-2-line', count: '180+部' },
  { title: '高分悬疑剧场', desc: '豆瓣8分以上悬疑推理剧全集，烧脑神作一次看完', icon: 'ri-search-eye-line', count: '120+部' },
  { title: '最新大结局专区', desc: '近期完结电视剧大结局汇总，热播剧第一时间更新完整版', icon: 'ri-timer-flash-line', count: '每日更新' },
];

export default function IndexSection() {
  return (
    <section id="index" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              剧集索引
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              按分类快速找到你想看的电视剧全集与连续剧完整版
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex items-start gap-4 bg-background-100 rounded-xl p-5 border border-background-300/30 hover:border-primary-500/40 cursor-pointer transition-all duration-200"
              >
                <div className="w-11 h-11 rounded-lg bg-primary-500/15 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500/25 transition-colors">
                  <i className={`${item.icon} text-primary-400 text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1.5">
                    <h3 className="text-foreground-100 text-sm font-medium whitespace-nowrap">
                      {item.title}
                    </h3>
                    <span className="text-accent-400 text-xs font-medium whitespace-nowrap ml-3">
                      {item.count}
                    </span>
                  </div>
                  <p className="text-foreground-500 text-xs leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}